/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { Flex, Spacer } from "@chakra-ui/react";
import environment from "constants/apiConst";
import { ButtonItemsForm } from "pages/Pass-Form/stylePases";
import { __ObtenerQrCustoms } from "request/CustomsClearance.js/__CustomsClearence";
import { useSelector } from "react-redux";

/* DEPRECATED -> ModalQR instead of this component */

export const QrCustomsClearence = ({ onClose }) => {
  const [first, setfirst] = useState("");
  const token = useSelector((state) => state.auth.dataUser.token);

  useEffect(() => {
    obtenerQr();
  }, []);

  const obtenerQr = async () => {
    const URLactual = window.location.href;
    const data = {
      url: URLactual
    };
    try {
      const res = await __ObtenerQrCustoms(
        environment.GET_QR_CUSTOMS_CLEARANCE,
        token,
        data
      );
      setfirst(res?.data?.status?.data);
    } catch (error) {}
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <img style={{ width: `50%` }} alt="" src={first} />
      </div>

      <Flex mt={6}>
        <Spacer />
        <ButtonItemsForm color="grisaso" onClick={onClose}>
          Cancelar
        </ButtonItemsForm>
      </Flex>
    </>
  );
};
